import React, { ReactNode, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Mode } from '../profile.type';
import PageBreadcrumb, {
  PageBreadcrumbItem
} from 'components/common/PageBreadcrumb';
import Button from 'components/base/Button';
import { routeMapping } from '../config';
import { FormRefMapping, Props } from './profileEdit.type';
import InstitutionProfile from './form/institutionProfile/InstitutionProfile';
import { FormikProps } from 'formik';
import { InstitutionProfileFormValue } from './form/institutionProfile/institutionProfile.type';
import CandidateProfile from './form/candidateProfile/CandidateProfile';
import { CandidateProfileFormValue } from './form/candidateProfile/candidateProfile.type';
import RecruiterProfile from './form/recruiterProfile/RecruiterProfile';
import { RecruiterProfileFormValue } from './form/recruiterProfile/recruiterProfile.type';

const defaultBreadcrumbItems: Record<Mode, PageBreadcrumbItem[]> = {
  institution: [
    {
      label: 'Profile',
      url: '/hub/profile/view'
    },
    {
      label: 'Edit Profile',
      url: '/hub/profile/edit',
      active: true
    }
  ],
  candidate: [
    {
      label: 'Profile',
      url: '/home/profile/view'
    },
    {
      label: 'Edit Profile',
      url: '/home/profile/edit',
      active: true
    }
  ],
  recruiter: [
    {
      label: 'Profile',
      url: '/panel/profile/view'
    },
    {
      label: 'Edit Profile',
      url: '/panel/profile/edit',
      active: true
    }
  ]
};

function ProfileEdit({ mode }: Props) {
  const [isLoading, setIsLoading] = useState(false);

  const institutionFormRef =
    useRef<FormikProps<InstitutionProfileFormValue> | null>(null);
  const candidateFormRef =
    useRef<FormikProps<CandidateProfileFormValue> | null>(null);
  const recruiterFormRef =
    useRef<FormikProps<RecruiterProfileFormValue> | null>(null);
  const formMapping: Record<Mode, ReactNode> = {
    institution: <InstitutionProfile innerRef={institutionFormRef} />,
    candidate: <CandidateProfile innerRef={candidateFormRef} />,
    recruiter: <RecruiterProfile innerRef={recruiterFormRef} />
  };
  const formRefMapping: FormRefMapping = {
    institution: institutionFormRef,
    candidate: candidateFormRef,
    recruiter: recruiterFormRef
  };

  const handleSubmit = () => {
    setIsLoading(true);
    formRefMapping[mode].current?.submitForm().then(() => setIsLoading(false));
  };

  return (
    <>
      <PageBreadcrumb items={defaultBreadcrumbItems[mode]} />
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="mb-0">Edit Profile</h2>
        </Col>
        <Col xs="auto" className="d-flex flex-wrap gap-2 gap-sm-3">
          <Button
            variant="phoenix-secondary"
            as={Link}
            to={routeMapping[mode].view}
          >
            Back
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            loading={isLoading}
            loadingPosition="start"
          >
            Save Changes
          </Button>
        </Col>
      </Row>
      {formMapping[mode]}
    </>
  );
}

export default ProfileEdit;
